import compose from 'react-hooks-compose'

import { useLogic } from './useLogic'
import { Presenter } from './presenter'

export const UpdateNavbar = compose({ useLogic })(Presenter)
